// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../Fuel/font/digital-7.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*media breaks*/
@font-face {
  font-family: "digital-clock-font";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
.manager__eod {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
}
.manager__eod .eod {
  margin: 2% auto;
  min-height: 58.5vh;
}
.manager__eod .eod select {
  width: 50%;
  margin: 0 auto 5% 25%;
  border: 1px solid #64c4e0;
  height: 2rem;
  border-radius: 1rem;
  background-color: #fff;
}
.manager__eod .eod .eod__values {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  margin-top: 3%;
}
.manager__eod .eod .eod__values h3 {
  color: #4d4d4d;
  font-size: 1.75rem;
}
.manager__eod .eod .eod__values h3 span {
  color: #2c53a0;
}
.manager__eod .eod .eod__values h4 {
  color: #4d4d4d;
}
.manager__eod .eod .eod__values h4 span {
  color: #2c53a0;
}
.manager__eod .eod .eod__values input[type=text] {
  border: 1px solid #64c4e0;
  height: 2rem;
  border-radius: 1rem;
}
.manager__eod .eod .eod__values .bagnote_input {
  border: 1px solid #64c4e0;
  height: 2rem;
  border-radius: 1rem;
  width: 30%;
  text-align: center;
  margin-bottom: 20px;
}
.manager__eod .eod .eod__values table {
  width: 80%;
  margin: auto;
  table-layout: fixed;
  border-collapse: collapse;
  background-color: #fff;
}
.manager__eod .eod .eod__values table thead {
  border-bottom: 1px solid #2c53a0;
}
.manager__eod .eod .eod__values table tbody tr {
  border-bottom: 1px solid #4d4d4d;
}
.manager__eod .eod .eod__values table tbody tr td {
  text-align: center;
}
.manager__eod .eod .eod__values table tbody tr td input[type=number] {
  width: 35%;
  margin: auto;
  text-align: center;
}
.manager__eod .eod .eod__values table tbody .selected__row__shift {
  background-color: #2c53a0;
  color: #fff;
}
.manager__eod .eod .eod__values textarea {
  margin: 2% auto 0 auto;
}
.manager__eod .eod .eod__values .step__btn {
  margin: 2% auto;
}
.manager__eod .eod .eod__values .denominations {
  width: 50%;
  margin: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
}
.manager__eod .eod .eod__values .denominations .denomination__row {
  width: 12vw;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin: 0.5% 0;
}
.manager__eod .eod .eod__values .denominations .denomination__row label {
  color: #4d4d4d;
  font-weight: 800;
}
.manager__eod .eod .eod__values .denominations .denomination__row .shake {
  animation: shake 0.82s cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
  transform: translate3d(0, 0, 0);
  backface-visibility: hidden;
  perspective: 1000px;
  color: #d90d1e !important;
}
.manager__eod .eod .eod__values .denominations .denomination__row input {
  border: 1px solid #64c4e0;
  height: 1.5rem;
  width: 50%;
  margin-left: 20%;
}
.manager__eod .eod .eod__values .denominations .driveOff__row {
  width: 22vw;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin: 0.5% 0;
}
.manager__eod .eod .eod__values .denominations .driveOff__row label {
  color: #4d4d4d;
  font-weight: 800;
}
.manager__eod .eod .eod__values .denominations .driveOff__row input {
  border: 1px solid #64c4e0;
  height: 1.5rem;
  width: 20%;
  margin-left: 20%;
}
.manager__eod .eod .eod__values .noDate {
  margin: 0 auto;
  padding: 20px;
  background-color: white;
  border: 2px solid #2c53a0;
  width: 50%;
}
.manager__eod .eod .eod__values .noDate h3 {
  text-align: center;
}
.manager__eod .eod .eod__values #fin_btn {
  margin: 2% auto;
  background-color: white;
  border: 1px solid green;
  color: green;
  height: 2rem;
}
.manager__eod .disc__modal {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 2%;
}
.manager__eod .disc__modal .disc__modal__row {
  display: flex;
  width: 50%;
  align-items: center;
  justify-content: space-evenly;
}
.manager__eod .disc__modal h4 span {
  color: #2c53a0;
}
.manager__eod .investigation__row {
  display: flex;
  align-items: flex-start;
  justify-content: space-evenly;
  width: 90%;
  margin: 0 auto;
}

.history__eod .epos__search {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
}
.history__eod .epos__search .epos__filters {
  background-color: #fff;
  box-shadow: 4px 2px 8px rgba(0, 0, 0, 0.2);
  border-radius: 1rem;
  width: 50vw;
  min-height: 10vh;
  margin: 1% auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  padding: 2% 1%;
}
.history__eod .epos__search .epos__filters .filters__search {
  display: flex;
  justify-content: center;
  align-items: center;
}
.history__eod .epos__search .epos__filters .filters__search input[type=text] {
  margin-left: 30px;
  border-radius: 0.5rem;
  background-color: #fff;
  border: 1px solid #2c53a0;
  padding: 5px;
}
.history__eod .epos__search .epos__filters input[type=date] {
  border-radius: 0.5rem;
  background-color: #fff;
  border: 1px solid #2c53a0;
  width: 200px;
}
.history__eod .epos__search .epos__filters .date-search-button {
  margin-left: 5px;
}
.history__eod .epos__search .epos__filters .filters__shown {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  width: 100%;
  margin: 3% auto;
}
.history__eod .epos__search .epos__filters .filters__shown .filters__column {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
}
.history__eod .epos__search .epos__filters .filters__shown .filters__column label {
  color: #4d4d4d;
  font-size: 0.9rem;
}
.history__eod .epos__search .epos__filters .filters__shown .filters__column select {
  border: 1px solid #2c53a0;
  border-radius: 0.5rem;
}
.history__eod .epos__search .epos__filters .filters__shown .filters__column input[type=text] {
  width: 80%;
  border: 1px solid #2c53a0;
  border-radius: 0.5rem;
}

.manager__banking {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  min-height: 79.5vh;
}
.manager__banking .banking__row {
  width: 80vw;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  flex-wrap: wrap;
  margin: 0 auto;
}
.manager__banking .banking__row .row__btn {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  align-items: center;
  appearance: none;
  background-color: #fcfcfd;
  border-radius: 4px;
  border-width: 0;
  box-shadow: rgba(45, 35, 66, 0.4) 0 2px 4px, rgba(45, 35, 66, 0.3) 0 7px 13px -3px, #d6d6e7 0 -3px 0 inset;
  box-sizing: border-box;
  color: #36395a;
  cursor: pointer;
  display: inline-flex;
  font-family: "JetBrains Mono", monospace;
  height: 100px;
  justify-content: center;
  line-height: 1;
  list-style: none;
  overflow: hidden;
  padding-left: 16px;
  padding-right: 16px;
  position: relative;
  text-align: left;
  text-decoration: none;
  transition: box-shadow 0.15s, transform 0.15s;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  white-space: nowrap;
  will-change: box-shadow, transform;
  font-size: 18px;
  margin-bottom: 2%;
}
.manager__banking .banking__row .row__btn:focus {
  box-shadow: #d6d6e7 0 0 0 1.5px inset, rgba(45, 35, 66, 0.4) 0 2px 4px, rgba(45, 35, 66, 0.3) 0 7px 13px -3px, #d6d6e7 0 -3px 0 inset;
}
.manager__banking .banking__row .row__btn:hover {
  box-shadow: rgba(45, 35, 66, 0.4) 0 4px 8px, rgba(45, 35, 66, 0.3) 0 7px 13px -3px, #d6d6e7 0 -3px 0 inset;
  transform: translateY(-2px);
}
.manager__banking .banking__row .row__btn:active {
  box-shadow: #d6d6e7 0 3px 7px inset;
  transform: translateY(2px);
}
.manager__banking .banking__row .row__btn p {
  margin: 0;
  font-family: "JetBrains Mono", monospace;
}
.manager__banking table {
  margin: 5% auto;
  width: 80%;
  table-layout: fixed;
  background-color: #fff;
  border-collapse: collapse;
}
.manager__banking table thead {
  border-bottom: 1px solid #4d4d4d;
  text-align: center;
}
.manager__banking table tbody {
  text-align: center;
}
.manager__banking table tbody tr {
  border-bottom: 1px solid #4d4d4d;
}
.manager__banking table tbody tr:nth-child(odd) {
  background-color: #f2f2f2;
}
.manager__banking table tbody tr td {
  word-break: break-all;
}
.manager__banking table tbody .length__alert {
  animation: tooLong 4s infinite ease !important;
}
@media (max-width: 600px) {
  .manager__banking .banking__row .row__btn {
    margin-bottom: 2%;
  }
  .manager__banking table {
    width: 100%;
    word-break: break-all;
    font-size: 0.75rem;
  }
}

.disc__modal table {
  margin: 5% auto;
  width: 90%;
  table-layout: fixed;
  background-color: #fff;
  border-collapse: collapse;
}
.disc__modal table thead {
  border-bottom: 1px solid #4d4d4d;
  text-align: center;
}
.disc__modal table tbody {
  text-align: center;
}
.disc__modal table tbody tr {
  border-bottom: 1px solid #4d4d4d;
}
.disc__modal table tbody tr:nth-child(odd) {
  background-color: #f2f2f2;
}
.disc__modal table tbody tr td {
  word-break: break-all;
}
.disc__modal table tbody .length__alert {
  animation: tooLong 4s infinite ease !important;
}

.status__modal {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 80%;
  margin: auto;
}
.status__modal .status__modal__row {
  width: 90%;
  margin: 2% auto;
  display: flex;
  align-items: center;
  justify-content: center;
}

.images__page {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  min-height: 100vh;
  color: #4d4d4d;
}
.images__page h2 {
  color: #4d4d4d;
  width: 80%;
  margin: 3% auto;
  text-align: center;
  text-transform: uppercase;
  font-size: 2rem;
}
.images__page .image__selection {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
}
.images__page .image__selection select,
.images__page .image__selection input {
  background-color: #fff;
  border-radius: 0.5rem;
  border: 1px solid #64c4e0;
  height: 2rem;
}
.images__page .image__selection input {
  margin: 5% auto;
}
.images__page .show__images {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 0;
}
.images__page .show__images table {
  width: 90%;
  table-layout: fixed;
  background-color: #fff;
  border-collapse: collapse;
}
.images__page .show__images table thead {
  border-bottom: 1px solid #4d4d4d;
  text-align: center;
}
.images__page .show__images table tbody {
  text-align: center;
}
.images__page .show__images table tbody tr {
  border-bottom: 1px solid #4d4d4d;
}
.images__page .show__images table tbody tr img {
  width: 100%;
}

#test {
  position: absolute;
  width: 60vw;
  height: 70vh;
  border: none;
  border-radius: 1rem;
  box-shadow: 24;
  background-color: #000;
  color: #fff;
  z-index: 1000;
  margin: 0 0 0 -5%;
}
#test .transit__modal {
  display: flex;
  align-items: flex-start;
  justify-content: space-evenly;
  width: 95%;
  margin: 2% auto;
}
#test .transit__modal .modal__denominations {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
#test .transit__modal .modal__denominations table {
  width: 90%;
  table-layout: fixed;
  background-color: #000;
  border-collapse: collapse;
  color: #fff;
}
#test .transit__modal .modal__denominations table thead {
  border-bottom: 1px solid #4d4d4d;
  text-align: center;
}
#test .transit__modal .modal__denominations table tbody {
  text-align: center;
}
#test .transit__modal .modal__denominations table tbody tr {
  color: #4d4d4d;
  border-bottom: 1px solid #4d4d4d;
}
#test .transit__modal .modal__denominations table tbody tr:nth-child(even) {
  background-color: #f2f2f2;
}

@keyframes tooLong {
  0% {
    background-color: transparent;
    color: #4d4d4d;
  }
  50% {
    background-color: #bb0000;
    color: #fff;
  }
  100% {
    background-color: transparent;
    color: #4d4d4d;
  }
}
@keyframes shake {
  10%, 90% {
    transform: translate3d(-1px, 0, 0);
  }
  20%, 80% {
    transform: translate3d(2px, 0, 0);
  }
  30%, 50%, 70% {
    transform: translate3d(-4px, 0, 0);
  }
  40%, 60% {
    transform: translate3d(4px, 0, 0);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/variables.scss","webpack://./src/components/managerZone/eod/eod.scss"],"names":[],"mappings":"AAOA,eAAA;AAeA;EACI,iCAAA;EACA,4CAAA;ACpBJ;AAFA;EDkEI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,2BAAA;AC7DJ;AANI;EACI,eAAA;EACA,kBAAA;AAQR;AAPQ;EACI,UAAA;EACA,qBAAA;EACA,yBAAA;EACA,YAAA;EACA,mBAAA;EACA,sBAAA;AASZ;AAPQ;EDqDJ,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,2BAAA;ECtDQ,cAAA;AAYZ;AAXY;EACI,cDhBJ;ECiBI,kBAAA;AAahB;AAZgB;EACI,cDtBR;ACoCZ;AAXY;EACI,cDvBJ;ACoCZ;AAZgB;EACI,cD5BR;AC0CZ;AAXY;EACI,yBAAA;EACA,YAAA;EACA,mBAAA;AAahB;AAXY;EACI,yBAAA;EACA,YAAA;EACA,mBAAA;EACA,UAAA;EACA,kBAAA;EACA,mBAAA;AAahB;AAXY;EACI,UAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;AAahB;AAZgB;EACI,gCAAA;AAcpB;AAXoB;EACI,gCAAA;AAaxB;AAZwB;EACI,kBAAA;AAc5B;AAb4B;EACI,UAAA;EACA,YAAA;EACA,kBAAA;AAehC;AAXoB;EACI,yBDlEZ;ECmEY,WAAA;AAaxB;AATY;EACI,sBAAA;AAWhB;AATY;EACI,eAAA;AAWhB;AATY;EACI,UAAA;EACA,YAAA;EDXZ,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,2BAAA;ACuBJ;AAbgB;EACI,WAAA;EACA,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,cAAA;AAepB;AAdoB;EACI,cDrFZ;ECsFY,gBAAA;AAgBxB;AAdoB;EACI,gEAAA;EAEA,+BAAA;EACA,2BAAA;EACA,mBAAA;EACA,yBAAA;AAexB;AAboB;EACI,yBAAA;EACA,cAAA;EACA,UAAA;EACA,gBAAA;AAexB;AAZgB;EACI,WAAA;EACA,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,cAAA;AAcpB;AAboB;EACI,cD9GZ;EC+GY,gBAAA;AAexB;AAboB;EACI,yBAAA;EACA,cAAA;EACA,UAAA;EACA,gBAAA;AAexB;AAXY;EACI,cAAA;EACA,aAAA;EACA,uBAAA;EACA,yBAAA;EACA,UAAA;AAahB;AAZgB;EACI,kBAAA;AAcpB;AAXY;EACI,eAAA;EACA,uBAAA;EACA,uBAAA;EACA,YAAA;EACA,YAAA;AAahB;AATI;EDlFA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;ECiFI,cAAA;AAcR;AAbQ;EACI,aAAA;EACA,UAAA;EACA,mBAAA;EACA,6BAAA;AAeZ;AAZY;EACI,cD1JJ;ACwKZ;AAVI;EACI,aAAA;EACA,uBAAA;EACA,6BAAA;EACA,UAAA;EACA,cAAA;AAYR;;AAPI;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,2BAAA;AAUR;AARQ;ED9IJ,sBAAA;EAJA,0CAAA;EAMA,mBAAA;EC8IQ,WAAA;EACA,gBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;EACA,cAAA;AAYZ;AAVY;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;AAYhB;AAVgB;EACI,iBAAA;EACA,qBAAA;EACA,sBAAA;EACA,yBAAA;EACA,YAAA;AAYpB;AATY;EACI,qBAAA;EACA,sBAAA;EACA,yBAAA;EACA,YAAA;AAWhB;AARY;EACI,gBAAA;AAUhB;AAPY;EACI,aAAA;EACA,6BAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;AAShB;AAPgB;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,2BAAA;AASpB;AAPoB;EACI,cD5NZ;EC6NY,iBAAA;AASxB;AANoB;EACI,yBAAA;EACA,qBAAA;AAQxB;AALoB;EACI,UAAA;EACA,yBAAA;EACA,qBAAA;AAOxB;;AACA;ED/KI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,2BAAA;EC8KA,kBAAA;AAKJ;AAJI;EACI,WAAA;ED/JJ,aAAA;EACA,mBAAA;EACA,6BAAA;EACA,eAAA;EC8JI,cAAA;AASR;AARQ;ED7LJ,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EC4LQ,mBAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,0GAAA;EAEA,sBAAA;EACA,cAAA;EACA,eAAA;EACA,oBAAA;EACA,wCAAA;EACA,aAAA;EACA,uBAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,qBAAA;EACA,6CAAA;EACA,iBAAA;EACA,yBAAA;EACA,0BAAA;EACA,mBAAA;EACA,kCAAA;EACA,eAAA;EACA,iBAAA;AAYZ;AAXY;EACI,qIAAA;AAahB;AARY;EACI,0GAAA;EAGA,2BAAA;AAQhB;AANY;EACI,mCAAA;EACA,0BAAA;AAQhB;AANY;EACI,SAAA;EACA,wCAAA;AAQhB;AAHI;EACI,eAAA;EACA,UAAA;EACA,mBAAA;EACA,sBAAA;EACA,yBAAA;AAKR;AAJQ;EACI,gCAAA;EACA,kBAAA;AAMZ;AAJQ;EACI,kBAAA;AAMZ;AALY;EACI,gCAAA;AAOhB;AANgB;EACI,yBAAA;AAQpB;AANgB;EACI,qBAAA;AAQpB;AALY;EACI,8CAAA;AAOhB;AAHI;EAEQ;IACI,iBAAA;EAId;EADM;IACI,WAAA;IACA,qBAAA;IACA,kBAAA;EAGV;AACF;;AAEI;EACI,eAAA;EACA,UAAA;EACA,mBAAA;EACA,sBAAA;EACA,yBAAA;AACR;AAAQ;EACI,gCAAA;EACA,kBAAA;AAEZ;AAAQ;EACI,kBAAA;AAEZ;AADY;EACI,gCAAA;AAGhB;AAFgB;EACI,yBAAA;AAIpB;AAFgB;EACI,qBAAA;AAIpB;AADY;EACI,8CAAA;AAGhB;;AAGA;EDzTI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;ECwTA,UAAA;EACA,YAAA;AAGJ;AAFI;EACI,UAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAIR;;AAAA;ED/TI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,2BAAA;EC8TA,iBAAA;EACA,cDnYQ;ACyYZ;AALI;EACI,cDrYI;ECsYJ,UAAA;EACA,eAAA;EACA,kBAAA;EACA,yBAAA;EACA,eAAA;AAOR;AALI;ED3UA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,2BAAA;ACmVJ;AATQ;;EAEI,sBAAA;EACA,qBAAA;EACA,yBAAA;EACA,YAAA;AAWZ;AATQ;EACI,eAAA;AAWZ;AARI;ED/VA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EC8VI,aAAA;AAaR;AAZQ;EACI,UAAA;EACA,mBAAA;EACA,sBAAA;EACA,yBAAA;AAcZ;AAbY;EACI,gCAAA;EACA,kBAAA;AAehB;AAbY;EACI,kBAAA;AAehB;AAdgB;EACI,gCAAA;AAgBpB;AAfoB;EACI,WAAA;AAiBxB;;AATA;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,cAAA;EACA,sBAAA;EACA,WAAA;EACA,aAAA;EACA,iBAAA;AAYJ;AAXI;EACI,aAAA;EACA,uBAAA;EACA,6BAAA;EACA,UAAA;EACA,eAAA;AAaR;AAZQ;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;AAcZ;AAbY;EACI,UAAA;EACA,mBAAA;EACA,sBAAA;EACA,yBAAA;EACA,WAAA;AAehB;AAdgB;EACI,gCAAA;EACA,kBAAA;AAgBpB;AAdgB;EACI,kBAAA;AAgBpB;AAfoB;EACI,cDrdZ;ECsdY,gCAAA;AAiBxB;AAhBwB;EACI,yBAAA;AAkB5B;;AAVA;EACI;IACI,6BAAA;IACA,cDneI;ECgfV;EAXE;IACI,yBDreA;ICseA,WAAA;EAaN;EAXE;IACI,6BAAA;IACA,cD3eI;ECwfV;AACF;AAXA;EACI;IAEI,kCAAA;EAYN;EATE;IAEI,iCAAA;EAUN;EAPE;IAGI,kCAAA;EAON;EAJE;IAEI,iCAAA;EAKN;AACF","sourcesContent":["$nitroDark: #2c53a0;\n$nitroLight: #64c4e0;\n$background: #e4ffff;\n$fontColor: #4d4d4d;\n$error: #bb0000;\n$warning: #f29422;\n\n/*media breaks*/\n$mobile: 600px;\n$tablet: 768px;\n$laptop: 900px;\n$tabletMin: 691px;\n$tabletMax: 850px;\n$landsTabletMin: 851px;\n$landsTabletMax: 1300px;\n$smallLaptopMin: 1301px;\n$smallLaptopMax: 1439px;\n$smallScreen: 1440px;\n$regularScreen: 1900px;\n$bigScreen: 1920px;\n$fourK: 2000px;\n\n@font-face {\n    font-family: \"digital-clock-font\";\n    src: url(\"./Fuel/font/digital-7.ttf\");\n}\n\n@mixin shadow {\n    box-shadow: 4px 2px 8px rgba(0, 0, 0, 0.2);\n}\n\n@mixin card {\n    background-color: #fff;\n    @include shadow;\n    border-radius: 1rem;\n}\n\n@mixin alertCard {\n    box-shadow: rgba(0, 0, 0, 0.19) 0px 10px 20px,\n        rgba(0, 0, 0, 0.23) 0px 6px 6px;\n    background-color: #fff;\n    border-radius: 0.5rem;\n}\n\n@mixin eposCard {\n    background-color: #fff;\n    box-shadow: rgba(0, 0, 0, 0.09) 0px 2px 1px, rgba(0, 0, 0, 0.09) 0px 4px 2px,\n        rgba(0, 0, 0, 0.09) 0px 8px 4px, rgba(0, 0, 0, 0.09) 0px 16px 8px,\n        rgba(0, 0, 0, 0.09) 0px 32px 16px;\n}\n\n@mixin flex($d: row, $j: center, $a: center, $g: 1vw) {\n    display: flex;\n    flex-wrap: wrap;\n    flex-direction: $d;\n    justify-content: $j;\n    align-items: $a;\n    gap: $g;\n}\n\n@mixin columnStack {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n}\n\n@mixin columnStart {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: flex-start;\n}\n@mixin columnAlignStart {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: center;\n}\n\n@mixin columnAlignStartTop {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: flex-start;\n}\n\n@mixin rowEven {\n    display: flex;\n    align-items: center;\n    justify-content: space-evenly;\n    flex-wrap: wrap;\n}\n\n@mixin rowEvenStart {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-evenly;\n}\n@mixin rowEvenStartCenter {\n    display: flex;\n    align-items: center;\n    justify-content: space-evenly;\n}\n\n@mixin rowStart {\n    display: flex;\n    align-items: flex-start;\n    justify-content: center;\n}\n@mixin rowBetween {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n@mixin rowBetweenStart {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n}\n\n@mixin rowCenter {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n@mixin rowStart {\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n}\n\n@mixin table {\n    table-layout: fixed;\n    background-color: #fff;\n    border-collapse: collapse;\n    color: $fontColor;\n    thead {\n        border-bottom: 1px solid $fontColor;\n        text-align: center;\n    }\n    tbody {\n        text-align: center;\n        tr {\n            border-bottom: 1px solid $fontColor;\n            &:nth-child(odd) {\n                background-color: #f2f2f2;\n            }\n            input {\n                width: 20%;\n                margin: 0 auto;\n                text-align: center;\n            }\n        }\n    }\n}\n\n//MODAL STYLING\n\n@mixin modal($h: auto, $w: auto) {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    width: $w;\n    height: $h;\n    max-height: 50vh;\n    background-color: #fff;\n    border: 2px solid #000;\n    box-shadow: 24;\n    padding: 10px;\n    overflow-y: auto;\n    @media (max-width: 600px) {\n        width: 95vw;\n    }\n}\n","@import \"../../variables.scss\";\n\n.manager__eod {\n    @include columnStart;\n    .eod {\n        margin: 2% auto;\n        min-height: 58.5vh;\n        select {\n            width: 50%;\n            margin: 0 auto 5% 25%;\n            border: 1px solid $nitroLight;\n            height: 2rem;\n            border-radius: 1rem;\n            background-color: #fff;\n        }\n        .eod__values {\n            @include columnStart;\n            margin-top: 3%;\n            h3 {\n                color: $fontColor;\n                font-size: 1.75rem;\n                span {\n                    color: $nitroDark;\n                }\n            }\n            h4 {\n                color: $fontColor;\n                span {\n                    color: $nitroDark;\n                }\n            }\n            input[type=\"text\"] {\n                border: 1px solid $nitroLight;\n                height: 2rem;\n                border-radius: 1rem;\n            }\n            .bagnote_input {\n                border: 1px solid $nitroLight;\n                height: 2rem;\n                border-radius: 1rem;\n                width: 30%;\n                text-align: center;\n                margin-bottom: 20px;\n            }\n            table {\n                width: 80%;\n                margin: auto;\n                table-layout: fixed;\n                border-collapse: collapse;\n                background-color: #fff;\n                thead {\n                    border-bottom: 1px solid $nitroDark;\n                }\n                tbody {\n                    tr {\n                        border-bottom: 1px solid $fontColor;\n                        td {\n                            text-align: center;\n                            input[type=\"number\"] {\n                                width: 35%;\n                                margin: auto;\n                                text-align: center;\n                            }\n                        }\n                    }\n                    .selected__row__shift {\n                        background-color: $nitroDark;\n                        color: #fff;\n                    }\n                }\n            }\n            textarea {\n                margin: 2% auto 0 auto;\n            }\n            .step__btn {\n                margin: 2% auto;\n            }\n            .denominations {\n                width: 50%;\n                margin: auto;\n                @include columnStart;\n                .denomination__row {\n                    width: 12vw;\n                    display: flex;\n                    align-items: flex-start;\n                    justify-content: space-between;\n                    margin: 0.5% 0;\n                    label {\n                        color: $fontColor;\n                        font-weight: 800;\n                    }\n                    .shake {\n                        animation: shake 0.82s\n                            cubic-bezier(0.36, 0.07, 0.19, 0.97) both;\n                        transform: translate3d(0, 0, 0);\n                        backface-visibility: hidden;\n                        perspective: 1000px;\n                        color: #d90d1e !important;\n                    }\n                    input {\n                        border: 1px solid $nitroLight;\n                        height: 1.5rem;\n                        width: 50%;\n                        margin-left: 20%;\n                    }\n                }\n                .driveOff__row {\n                    width: 22vw;\n                    display: flex;\n                    align-items: flex-start;\n                    justify-content: space-between;\n                    margin: 0.5% 0;\n                    label {\n                        color: $fontColor;\n                        font-weight: 800;\n                    }\n                    input {\n                        border: 1px solid $nitroLight;\n                        height: 1.5rem;\n                        width: 20%;\n                        margin-left: 20%;\n                    }\n                }\n            }\n            .noDate {\n                margin: 0 auto;\n                padding: 20px;\n                background-color: white;\n                border: 2px solid $nitroDark;\n                width: 50%;\n                h3 {\n                    text-align: center;\n                }\n            }\n            #fin_btn {\n                margin: 2% auto;\n                background-color: #ffff;\n                border: 1px solid green;\n                color: green;\n                height: 2rem;\n            }\n        }\n    }\n    .disc__modal {\n        @include columnStack;\n        margin-top: 2%;\n        .disc__modal__row {\n            display: flex;\n            width: 50%;\n            align-items: center;\n            justify-content: space-evenly;\n        }\n        h4 {\n            span {\n                color: $nitroDark;\n            }\n        }\n    }\n    .investigation__row {\n        display: flex;\n        align-items: flex-start;\n        justify-content: space-evenly;\n        width: 90%;\n        margin: 0 auto;\n    }\n}\n\n.history__eod {\n    .epos__search {\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        justify-content: flex-start;\n\n        .epos__filters {\n            @include card;\n            width: 50vw;\n            min-height: 10vh;\n            margin: 1% auto;\n            display: flex;\n            align-items: center;\n            justify-content: space-between;\n            flex-wrap: wrap;\n            padding: 2% 1%;\n\n            .filters__search {\n                display: flex;\n                justify-content: center;\n                align-items: center;\n\n                input[type=\"text\"] {\n                    margin-left: 30px;\n                    border-radius: 0.5rem;\n                    background-color: #fff;\n                    border: 1px solid $nitroDark;\n                    padding: 5px;\n                }\n            }\n            input[type=\"date\"] {\n                border-radius: 0.5rem;\n                background-color: #fff;\n                border: 1px solid $nitroDark;\n                width: 200px;\n            }\n\n            .date-search-button {\n                margin-left: 5px;\n            }\n\n            .filters__shown {\n                display: flex;\n                justify-content: space-evenly;\n                align-items: center;\n                width: 100%;\n                margin: 3% auto;\n\n                .filters__column {\n                    display: flex;\n                    flex-direction: column;\n                    align-items: flex-start;\n                    justify-content: flex-start;\n\n                    label {\n                        color: $fontColor;\n                        font-size: 0.9rem;\n                    }\n\n                    select {\n                        border: 1px solid $nitroDark;\n                        border-radius: 0.5rem;\n                    }\n\n                    input[type=\"text\"] {\n                        width: 80%;\n                        border: 1px solid $nitroDark;\n                        border-radius: 0.5rem;\n                    }\n                }\n            }\n        }\n    }\n}\n\n.manager__banking {\n    @include columnStart;\n    min-height: 79.5vh;\n    .banking__row {\n        width: 80vw;\n        @include rowEven;\n        margin: 0 auto;\n        .row__btn {\n            @include columnStack;\n            align-items: center;\n            appearance: none;\n            background-color: #fcfcfd;\n            border-radius: 4px;\n            border-width: 0;\n            box-shadow: rgba(45, 35, 66, 0.4) 0 2px 4px,\n                rgba(45, 35, 66, 0.3) 0 7px 13px -3px, #d6d6e7 0 -3px 0 inset;\n            box-sizing: border-box;\n            color: #36395a;\n            cursor: pointer;\n            display: inline-flex;\n            font-family: \"JetBrains Mono\", monospace;\n            height: 100px;\n            justify-content: center;\n            line-height: 1;\n            list-style: none;\n            overflow: hidden;\n            padding-left: 16px;\n            padding-right: 16px;\n            position: relative;\n            text-align: left;\n            text-decoration: none;\n            transition: box-shadow 0.15s, transform 0.15s;\n            user-select: none;\n            -webkit-user-select: none;\n            touch-action: manipulation;\n            white-space: nowrap;\n            will-change: box-shadow, transform;\n            font-size: 18px;\n            margin-bottom: 2%;\n            &:focus {\n                box-shadow: #d6d6e7 0 0 0 1.5px inset,\n                    rgba(45, 35, 66, 0.4) 0 2px 4px,\n                    rgba(45, 35, 66, 0.3) 0 7px 13px -3px,\n                    #d6d6e7 0 -3px 0 inset;\n            }\n            &:hover {\n                box-shadow: rgba(45, 35, 66, 0.4) 0 4px 8px,\n                    rgba(45, 35, 66, 0.3) 0 7px 13px -3px,\n                    #d6d6e7 0 -3px 0 inset;\n                transform: translateY(-2px);\n            }\n            &:active {\n                box-shadow: #d6d6e7 0 3px 7px inset;\n                transform: translateY(2px);\n            }\n            p {\n                margin: 0;\n                font-family: \"JetBrains Mono\", monospace;\n            }\n        }\n    }\n\n    table {\n        margin: 5% auto;\n        width: 80%;\n        table-layout: fixed;\n        background-color: #fff;\n        border-collapse: collapse;\n        thead {\n            border-bottom: 1px solid $fontColor;\n            text-align: center;\n        }\n        tbody {\n            text-align: center;\n            tr {\n                border-bottom: 1px solid $fontColor;\n                &:nth-child(odd) {\n                    background-color: #f2f2f2;\n                }\n                td {\n                    word-break: break-all;\n                }\n            }\n            .length__alert {\n                animation: tooLong 4s infinite ease !important;\n            }\n        }\n    }\n    @media (max-width: $mobile) {\n        .banking__row {\n            .row__btn {\n                margin-bottom: 2%;\n            }\n        }\n        table {\n            width: 100%;\n            word-break: break-all;\n            font-size: 0.75rem;\n        }\n    }\n}\n\n.disc__modal {\n    table {\n        margin: 5% auto;\n        width: 90%;\n        table-layout: fixed;\n        background-color: #fff;\n        border-collapse: collapse;\n        thead {\n            border-bottom: 1px solid $fontColor;\n            text-align: center;\n        }\n        tbody {\n            text-align: center;\n            tr {\n                border-bottom: 1px solid $fontColor;\n                &:nth-child(odd) {\n                    background-color: #f2f2f2;\n                }\n                td {\n                    word-break: break-all;\n                }\n            }\n            .length__alert {\n                animation: tooLong 4s infinite ease !important;\n            }\n        }\n    }\n}\n\n.status__modal {\n    @include columnStack;\n    width: 80%;\n    margin: auto;\n    .status__modal__row {\n        width: 90%;\n        margin: 2% auto;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n    }\n}\n\n.images__page {\n    @include columnStart;\n    min-height: 100vh;\n    color: $fontColor;\n    h2 {\n        color: $fontColor;\n        width: 80%;\n        margin: 3% auto;\n        text-align: center;\n        text-transform: uppercase;\n        font-size: 2rem;\n    }\n    .image__selection {\n        @include columnStart;\n        select,\n        input {\n            background-color: #fff;\n            border-radius: 0.5rem;\n            border: 1px solid $nitroLight;\n            height: 2rem;\n        }\n        input {\n            margin: 5% auto;\n        }\n    }\n    .show__images {\n        @include columnStack;\n        margin-top: 0;\n        table {\n            width: 90%;\n            table-layout: fixed;\n            background-color: #fff;\n            border-collapse: collapse;\n            thead {\n                border-bottom: 1px solid $fontColor;\n                text-align: center;\n            }\n            tbody {\n                text-align: center;\n                tr {\n                    border-bottom: 1px solid $fontColor;\n                    img {\n                        width: 100%;\n                    }\n                }\n            }\n        }\n    }\n}\n\n#test {\n    position: absolute;\n    width: 60vw;\n    height: 70vh;\n    border: none;\n    border-radius: 1rem;\n    box-shadow: 24;\n    background-color: #000;\n    color: #fff;\n    z-index: 1000;\n    margin: 0 0 0 -5%;\n    .transit__modal {\n        display: flex;\n        align-items: flex-start;\n        justify-content: space-evenly;\n        width: 95%;\n        margin: 2% auto;\n        .modal__denominations {\n            display: flex;\n            flex-direction: column;\n            align-items: center;\n            justify-content: center;\n            table {\n                width: 90%;\n                table-layout: fixed;\n                background-color: #000;\n                border-collapse: collapse;\n                color: #fff;\n                thead {\n                    border-bottom: 1px solid $fontColor;\n                    text-align: center;\n                }\n                tbody {\n                    text-align: center;\n                    tr {\n                        color: $fontColor;\n                        border-bottom: 1px solid $fontColor;\n                        &:nth-child(even) {\n                            background-color: #f2f2f2;\n                        }\n                    }\n                }\n            }\n        }\n    }\n}\n@keyframes tooLong {\n    0% {\n        background-color: transparent;\n        color: $fontColor;\n    }\n    50% {\n        background-color: $error;\n        color: #fff;\n    }\n    100% {\n        background-color: transparent;\n        color: $fontColor;\n    }\n}\n@keyframes shake {\n    10%,\n    90% {\n        transform: translate3d(-1px, 0, 0);\n    }\n\n    20%,\n    80% {\n        transform: translate3d(2px, 0, 0);\n    }\n\n    30%,\n    50%,\n    70% {\n        transform: translate3d(-4px, 0, 0);\n    }\n\n    40%,\n    60% {\n        transform: translate3d(4px, 0, 0);\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
